<template>
  <div class="col-md-9">
    <div class="col-md-6">
      <div class="input-group">
        <input type="text" class="form-control" :placeholder="$t( 'toolbar.placeholder_search')" :value="filterTemplateName" @input="setTemplateName" @keyup="handleEnter" />
        <span class="input-group-btn">
          <button class="btn btn-default" type="submit" @click="searchByName">{{ $t( 'toolbar.search') }}</button>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <tags-search />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import TagsSearch from './TagSearch.vue';

export default {
  name: 'SearchBar',
  components: {
    TagsSearch
  },
  computed: {
    ...mapState({
      filterTemplateName: state => state.filterTemplateName
    })
  },
  methods: {
    ...mapActions([
      'selectPage'
    ]),
    ...mapMutations([
      'setFilterTemplateName'
    ]),
    setTemplateName: function(event) {
      this.setFilterTemplateName(event.target.value);
    },
    searchByName: function() {
      // go to first page and search by template name
      this.selectPage(1);
    },
    handleEnter: function(event) {
      if (event.keyCode === 13) {
        this.searchByName();
      }
    }
  }
};
</script>

<style scoped>
input {
  height: 42px;
}
button {
  height: 42px;
}
</style>